/**
 * Production stop (parada) — named time that did not produce
 * (spec 0041 §2.4 / request 0186).
 *
 * Top-level collection: org/{orgId}/production-stop (not a subcollection).
 * Transactional: Auditable, no Inactivatable. Open ⇔ `endedAt == null`
 * (no `status` field — unlike ProductionRun, a stop has no paused state).
 *
 * Hybrid anchor: `runId` (stop born from an execution) and/or `machineId`
 * (machine idle with no run). At least one is required; without a run,
 * `machineId` is mandatory. No stock-ledger effect (D10).
 */
export const PRODUCTION_STOP = 'ProductionStop';
//# sourceMappingURL=production-stop.js.map